import routeNames from '@/router/routes'
const standardContactFields = [
  'languageCode',
  'phoneNumber',
  'email',
]
const genders = [
  {
    id: 'male',
  },
  {
    id: 'female',
  },
  {
    id: 'other',
  },
]
const documentTypes = [
  {
    id: 'ID_CARD',
    allowedKey: 'allowedIdCardNationalities',
  },
  {
    id: 'PASSPORT',
    allowedKey: 'allowedPassportNationalities',
  },
]
const reservationTypes = {
  IN_VENUE: 'IN_VENUE',
  ROOM_SERVICE: 'ROOM_SERVICE',
  EXTERNAL_RESERVATION_SYSTEM: 'EXTERNAL_RESERVATION_SYSTEM',
}
const activityReservationColorsByStatus = {
  ACCEPTED: { background: '#F2F7EC', text: '#34C56E', dot: '#34C56E' },
  PENDING: { background: '#FFF4E2', text: '#EEB453', dot: '#EEB453' },
  REJECTED: { background: '#FAEAE5', text: '#DC5528', dot: '#DC5528' },
  ATTENDED: { background: '#FFFFFF', text: '#737687', dot: '#737687' },
  ABSENT: { background: '#F2F8FB', text: '#BFDAED', dot: '#BFDAED' },
  CANCELLED: { background: '#FAEAE5', text: '#DC5528', dot: '#DC5528' },
  PENDING_MODIFICATION: { background: '#FFF4E2', text: '#EEB453', dot: '#EEB453' },
  FINISHED: { background: '#F5F5F5', text: '#B3B3B3', dot: '#B3B3B3' },
  UPDATED: { background: '#E4EAFF', text: '#284FD9', dot: '#284FD9' },
  ACCEPTED_BY_ACTIVITY_MODIFICATION: { background: '#F2F7EC', text: '#34C56E', dot: '#34C56E' },
  CANCELLED_BY_ACTIVITY_MODIFICATION: { background: '#FAEAE5', text: '#DC5528', dot: '#DC5528' },
  PENDING_PAYMENT: { background: '#FFF4E2', text: '#EEB453', dot: '#EEB453' },
  UPCOMING: { background: '#DD5059', text: 'white' },
}
const activityReservationColorsByStatusDark = {
  ACCEPTED: { background: '#34C56E', text: 'white', dot: '#34C56E' },
  PENDING: { background: '#EEB453', text: 'white', dot: '#EEB453' },
  REJECTED: { background: '#DC5528', text: 'white', dot: '#DC5528' },
  ATTENDED: { background: '#737687', text: 'white', dot: '#737687' },
  ABSENT: { background: '#BFDAED', text: 'white', dot: '#BFDAED' },
  CANCELLED: { background: '#DC5528', text: 'white', dot: '#DC5528' },
  PENDING_MODIFICATION: { background: '#EEB453', text: 'white', dot: '#EEB453' },
  UPDATED: { background: '#284FD9', text: 'white', dot: '#284FD9' },
  ACCEPTED_BY_ACTIVITY_MODIFICATION: { background: '#34C56E', text: 'white', dot: '#34C56E' },
  CANCELLED_BY_ACTIVITY_MODIFICATION: { background: '#DC5528', text: 'white', dot: '#DC5528' },
  PENDING_PAYMENT: { background: '#EEB453', text: 'white', dot: '#EEB453' },
  UPCOMING: { background: '#DD5059', text: 'white' },
}
const activityReservationStatus = {
  ACCEPTED: 'ACCEPTED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  ATTENDED: 'ATTENDED',
  ABSENT: 'ABSENT',
  CANCELLED: 'CANCELLED',
  PENDING_MODIFICATION: 'PENDING_MODIFICATION',
  FINISHED: 'FINISHED',
  UPDATED: 'UPDATED',
  ACCEPTED_BY_ACTIVITY_MODIFICATION: 'ACCEPTED_BY_ACTIVITY_MODIFICATION',
  CANCELLED_BY_ACTIVITY_MODIFICATION: 'CANCELLED_BY_ACTIVITY_MODIFICATION',
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  SUCCESS_PAYMENT: 'SUCCESS_PAYMENT', // not actual reservation status, used for payment completion
  PROCESSING_PAYMENT: 'PROCESSING_PAYMENT', // not actual reservation status, used for payment completion
}

const activityReservationLogStatus = {
  PAYMENT_ATTEMPT: 'PAYMENT_ATTEMPT',
  SUCCESS: 'SUCCESS',
  REFUNDED: 'REFUNDED',
  BLACKLISTED: 'BLACKLISTED',
  REFUSED: 'REFUSED',
}

const logTags = {
  ACTIVITY_RESERVATIONS_PAYMENT_ATTEMPT: 'ACTIVITY_RESERVATIONS#PAYMENT_ATTEMPT',
}

const orderLineTypes = {
  SALE: 'SALE',
  TAX: 'TAX',
  DISCOUNT: 'DISCOUNT',
  GRATUITY: 'GRATUITY',
  SERVICE_CHARGE: 'SERVICE_CHARGE',
}

const orderLineItemEntities = {
  PRODUCT: 'PRODUCT',
  ACTIVITY: 'ACTIVITY',
  RESERVATION_METHOD: 'RESERVATION_METHOD',
  CATALOG_PRODUCT_MODIFIER_OPTION: 'CATALOG_PRODUCT_MODIFIER_OPTION',
  RESERVATION_METHOD_ATTENDEE_TYPE: 'RESERVATION_METHOD_ATTENDEE_TYPE',
  ACCESS: 'ACCESS',
}

const modificationRequestConfig = {
  pending: { key: 'pending', color: 'orange accent-2', icon: 'mdi-clock-outline' },
  success: { key: 'success', color: 'light-green lighten-1', icon: 'mdi-check-circle-outline' },
  error: { key: 'error', color: 'red lighten-1', icon: 'mdi-alert' },
}

const currencyTypes = {
  SERVICE: 'SERVICE',
  VIRTUAL: 'VIRTUAL',
  ACCESS: 'ACCESS',
  OBJECT: 'OBJECT',
  LEGAL: 'LEGAL',
}

const capacityControlModes = {
  RESERVATIONS: 'RESERVATIONS',
  ATTENDEES: 'ATTENDEES',
}

const localHostNames = ['127.0.0.1', 'localhost', '::1']

const attendeeTypeConfigurationTypes = {
  NOMINAL: 'NOMINAL',
  NUMERAL: 'NUMERAL',
}

const timeFormats = {
  H_24: 'H_24',
  AM_PM: 'AM_PM',
}

const timeFormatFallback = timeFormats.H_24

const firstDayOfWeekOptions = {
  MONDAY: 'MONDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
}

const firstDayOfWeekFallback = firstDayOfWeekOptions.MONDAY

const pageTypes = {
  NAVIGATION: 'NAVIGATION',
  CONTENT: 'CONTENT',
  LINK: 'LINK',
  SERVICE: 'SERVICE',
  CROSS_SELL: 'CROSS_SELL',
  PRECONFIGURED: 'PRECONFIGURED',
}

const preconfiguredPageTypes = {
  SETTINGS: 'SETTINGS',
  BOOKING_INFORMATION: 'BOOKING_INFORMATION',
  ACTIVITY_RESERVATIONS: 'ACTIVITY_RESERVATIONS',
  UPCOMING_EVENTS: 'UPCOMING_EVENTS',
}

const preconfiguredPageRoutes = {
  SETTINGS: routeNames.settings.name,
  BOOKING_INFORMATION: routeNames.booking.name,
  ACTIVITY_RESERVATIONS: routeNames.activity_reservations.name,
  UPCOMING_EVENTS: routeNames.upcomingEvents.name,
}

const cardAppearanceTypes = {
  IMAGE: 'IMAGE',
  ICON: 'ICON',
}

export {
  standardContactFields,
  genders,
  documentTypes,
  reservationTypes,
  activityReservationColorsByStatus,
  activityReservationColorsByStatusDark,
  activityReservationStatus,
  orderLineTypes,
  orderLineItemEntities,
  modificationRequestConfig,
  currencyTypes,
  capacityControlModes,
  localHostNames,
  attendeeTypeConfigurationTypes,
  timeFormats,
  firstDayOfWeekOptions,
  timeFormatFallback,
  firstDayOfWeekFallback,
  activityReservationLogStatus,
  logTags,
  pageTypes,
  cardAppearanceTypes,
  preconfiguredPageRoutes,
  preconfiguredPageTypes,
}
